/* unplugin-vue-components disabled */import script from "./Dalle.vue?vue&type=script&setup=true&lang=js"
export * from "./Dalle.vue?vue&type=script&setup=true&lang=js"

import "./Dalle.vue?vue&type=style&index=0&id=3d66ce7d&lang=stylus"

const __exports__ = script;

export default __exports__